/*
 * TLS sticky add-to-cart bar (replaces the Vitals sticky ATC).
 * - visible while the product form's own add-to-cart button is out of view (same as Vitals)
 * - the label mirrors the real button ("In winkelwagen • 59,95", incl. the chosen Kaching bundle price); a label that
 *   does not fit (DE "In den Einkaufswagen legen • 34,95 €" on a phone) becomes the short label + price
 * - the button clicks the REAL button, so Kaching bundles, properties and the TLS cart drawer behave identically
 * - the variant dropdown clicks the matching Swatch King swatch / theme radio, and follows changes made above
 */
(function () {
  'use strict';
  var bar = document.getElementById('tls-sticky-atc');
  if (!bar) return;
  var form = document.querySelector('[data-section-type="product"] form[action*="/cart/add"]') ||
             document.querySelector('form[action*="/cart/add"]');
  var mainBtn = form && form.querySelector('[type="submit"]');
  if (!mainBtn) return;

  var btn = bar.querySelector('[data-tlss-add]');
  var select = bar.querySelector('[data-tlss-variant]');
  var variants = [];
  try { variants = JSON.parse(bar.querySelector('[data-tlss-variants]').textContent) || []; } catch (e) { /* none */ }
  var byId = {};
  variants.forEach(function (v) { byId[String(v.id)] = v; });
  var moneyFormat = bar.getAttribute('data-money-format') || '{{amount_with_comma_separator}}';

  function fmt(cents) {
    var n = (Number(cents || 0) / 100).toFixed(2).split('.');
    var comma = /comma/.test(moneyFormat);
    var whole = n[0].replace(/\B(?=(\d{3})+(?!\d))/g, comma ? '.' : ',');
    var amount = whole + (comma ? ',' : '.') + n[1];
    return moneyFormat.replace(/\{\{\s*\w+\s*\}\}/, amount);
  }
  // text exactly as the customer sees it in the real button (hidden state-spans skipped, no CSS uppercase)
  function visibleText(el) {
    var out = '';
    var w = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
    var n;
    while ((n = w.nextNode())) {
      var p = n.parentElement;
      if (!p) continue;
      var cs = getComputedStyle(p);
      if (cs.display === 'none' || cs.visibility === 'hidden') continue;
      if (!p.offsetWidth && !p.offsetHeight) continue;
      out += n.data;
    }
    return out.replace(/\s+/g, ' ').trim();
  }
  function syncLabel() {
    // Pipeline keeps the normal label in .btn-state-ready, also while it briefly shows "loading/added"
    var ready = mainBtn.querySelector('.btn-state-ready');
    var t = ready ? ready.textContent.replace(/\s+/g, ' ').trim() : visibleText(mainBtn);
    var def = bar.getAttribute('data-default-label');
    btn.textContent = t || def;
    // too long for the bar (DE "In den Einkaufswagen legen • 34,95 €"): short label + the price part after the last " • "
    var cut = t ? t.lastIndexOf(' • ') : -1;
    if (cut > 0 && def && btn.scrollWidth > btn.clientWidth) btn.textContent = def + t.slice(cut);
    btn.disabled = !!mainBtn.disabled;
  }
  function updateInfo(v) {
    if (!v) return;
    var price = bar.querySelector('[data-tlss-price]');
    var compare = bar.querySelector('[data-tlss-compare]');
    var img = bar.querySelector('[data-tlss-img]');
    if (price) price.textContent = fmt(v.price);
    if (compare) {
      compare.hidden = !(v.compare_at_price > v.price);
      compare.textContent = fmt(v.compare_at_price);
    }
    if (img && v.image) img.src = v.image;
  }
  function currentId() {
    var idIn = form.querySelector('[name="id"]');
    return idIn ? String(idIn.value) : '';
  }
  function syncFromMain() {
    var id = currentId();
    if (select && byId[id] && select.value !== id) select.value = id;
    updateInfo(byId[id]);
    syncLabel();
  }
  function selectInMain(v) {
    var scope = form.closest('[data-section-type="product"]') || document;
    var clicked = false;
    (v.options || []).forEach(function (val) {
      var cands = Array.prototype.filter.call(
        scope.querySelectorAll('.swatch-selector[data-value], variant-swatch-king [data-value]'),
        function (e) { return e.getAttribute('data-value') === val; });
      if (cands[0]) { cands[0].click(); clicked = true; return; }
      var radio = Array.prototype.filter.call(scope.querySelectorAll('input[type="radio"]'),
        function (r) { return r.value === val; })[0];
      if (radio) { radio.click(); clicked = true; }
    });
    if (!clicked) {
      var idIn = form.querySelector('[name="id"]');
      if (idIn) {
        idIn.value = v.id;
        idIn.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
    setTimeout(syncFromMain, 150);
  }

  btn.addEventListener('click', function () {
    if (mainBtn.disabled) return;
    mainBtn.click();
  });
  if (select) {
    select.addEventListener('change', function () {
      var v = byId[select.value];
      if (!v) return;
      updateInfo(v);
      selectInMain(v);
    });
  }

  // follow everything that happens in the main form (variant, Kaching bundle price, sold out)
  new MutationObserver(syncFromMain).observe(mainBtn, { subtree: true, childList: true, characterData: true, attributes: true });
  form.addEventListener('change', function () { setTimeout(syncFromMain, 60); });
  document.addEventListener('theme:variant:change', function () { setTimeout(syncFromMain, 60); });
  // the label check depends on the bar width (rotate / resize)
  var resizeT;
  window.addEventListener('resize', function () { clearTimeout(resizeT); resizeT = setTimeout(syncLabel, 150); });
  // the bar is hidden while the cart drawer is open (no width to measure): check the label again when it closes
  var locked = false;
  new MutationObserver(function () {
    var now = document.documentElement.classList.contains('tlsc-lock');
    if (locked && !now) syncLabel();
    locked = now;
  }).observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });

  // shown only once the customer has scrolled PAST the real button (it is above the screen); hidden while the button is
  // in view or still further down (venek 13 Oct; Vitals showed it from the first pixel of scrolling)
  var shown = null;
  function place() {
    var on = mainBtn.getBoundingClientRect().bottom < 0;
    if (on === shown) return;
    shown = on;
    if (on) syncFromMain();
    bar.classList.toggle('is-visible', on);
    bar.setAttribute('aria-hidden', on ? 'false' : 'true');
  }
  var ticking = false;
  window.addEventListener('scroll', function () {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(function () { ticking = false; place(); });
  }, { passive: true });
  syncFromMain();
  place();
})();
